'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (strings) {
	for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		values[_key - 1] = arguments[_key];
	}

	return styler(strings, values);
};

exports.styler = styler;
exports.is_pseudo_class = is_pseudo_class;
exports.is_media_query = is_media_query;
exports.is_keyframe_selector = is_keyframe_selector;
exports.is_keyframes = is_keyframes;

var _helpers = require('./helpers');

var _tabulator = require('./tabulator');

var _tabulator2 = _interopRequireDefault(_tabulator);

var _styleBuilder = require('style-builder');

var _styleBuilder2 = _interopRequireDefault(_styleBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// (the main function)
// Parses CSS into a JSON object
function styler(strings, values) {
	var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var style = '';

	// restore the whole string from "strings" and "values" parts
	var i = 0;
	while (i < strings.length) {
		style += strings[i];
		if ((0, _helpers.exists)(values[i])) {
			style += values[i];
		}
		i++;
	}

	return parse_style_json_object(style, options);
}

// converts text to JSON object


// using ES6 template strings
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/template_strings
function parse_style_json_object(text, options) {
	// remove multiline comments
	text = text.replace(/\/\*([\s\S]*?)\*\//g, '');

	// ignore curly braces for now.
	// maybe support curly braces along with tabulation in future
	text = text.replace(/[\{\}]/g, '');

	var lines = text.split('\n');

	// helper class for dealing with tabulation
	var tabulator = new _tabulator2.default(_tabulator2.default.determine_tabulation(lines));

	// parse text into JSON object
	var style_json = parse_style_class(tabulator.extract_tabulation(lines), []);

	// expand CSS shorthand properties
	// (e.g. `margin: 1px` -> `margin-left: 1px; ...`)
	if (options.expand) {
		style_json = _styleBuilder2.default.build(style_json);
	}

	// expand "modifier" style classes
	// (which can override some of the expanded shorthand CSS properties)
	return expand_modifier_style_classes(style_json);
}

// parse child nodes' lines (and this node's styles) into this node's style JSON object
function parse_node_json(styles, children_lines, node_names) {
	// transform this node's style lines from text to JSON properties and their values
	var style_object = styles.map(function (style) {
		var key = style.substring(0, style.indexOf(':')).trim();
		var value = style.substring(style.indexOf(':') + ':'.length).trim();

		// transform dashed key to camelCase key (it's required by React)
		key = key.replace(/([-]{1}[a-z]{1})/g, function (character) {
			return character.substring(1).toUpperCase();
		});

		// support old CSS syntax
		value = value.replace(/;$/, '').trim();

		// check if the value can be parsed into an integer
		if (String(parseInt(value)) === value) {
			value = parseInt(value);
		}

		// check if the value can be parsed into a float
		if (String(parseFloat(value)) === value) {
			value = parseFloat(value);
		}

		return { key: key, value: value };
	})
	// combine the styles into a JSON object
	.reduce(function (styles, style) {
		styles[style.key] = style.value;
		return styles;
	}, {});

	// parse child nodes and add them to this node's JSON object
	return (0, _helpers.extend)(style_object, parse_children(children_lines, node_names));
}

// separates style lines from children lines
function split_into_style_lines_and_children_lines(lines) {
	// get this node style lines
	var style_lines = lines.filter(function (line) {
		// styles always have indentation of 1
		if (line.tabs !== 1) {
			return false;
		}

		// detect generic css style line (skip modifier classes and media queries)
		var colon_index = line.line.indexOf(':');

		// is not a modifier class
		return !(0, _helpers.starts_with)(line.line, '&')
		// is not a media query style class name declaration
		&& !(0, _helpers.starts_with)(line.line, '@media')
		// is not a keyframes style class name declaration
		&& !(0, _helpers.starts_with)(line.line, '@keyframes')
		// has a colon
		&& colon_index >= 0
		// is not a state class (e.g. :hover) name declaration
		&& colon_index !== 0
		// is not a yaml-style class name declaration
		&& colon_index < line.line.length - 1;
	});

	// get children nodes' lines
	var children_lines = lines.filter(function (line) {
		return style_lines.indexOf(line) < 0;
	});

	// reduce tabulation for this child node's (or these child nodes') child nodes' lines
	children_lines.forEach(function (line) {
		return line.tabs--;
	});

	return { style_lines: style_lines, children_lines: children_lines };
}

// parses a style class node name
function parse_node_name(name) {
	// is it a "modifier" style class
	var is_a_modifier = false;

	// detect modifier style classes
	if ((0, _helpers.starts_with)(name, '&')) {
		name = name.substring('&'.length);
		is_a_modifier = true;
	}

	// support old-school CSS syntax
	if ((0, _helpers.starts_with)(name, '.')) {
		name = name.substring('.'.length);
	}

	// if there is a trailing colon in the style class name - trim it
	// (Python people with yaml-alike syntax)
	if ((0, _helpers.ends_with)(name, ':')) {
		name = name.substring(0, name.length - ':'.length);
		// throw new Error(`Remove the trailing colon at line: ${original_line}`)
	}

	return { name: name, is_a_modifier: is_a_modifier };
}

// parses child nodes' lines of text into the corresponding child node JSON objects
function parse_children(lines, parent_node_names) {
	// preprocess the lines (filter out comments, blank lines, etc)
	lines = filter_lines_for_parsing(lines);

	// return empty object if there are no lines to parse
	if (lines.length === 0) {
		return {};
	}

	// parse each child node's lines
	return split_lines_by_child_nodes(lines).map(function (lines) {
		// the first line is this child node's name (or names)
		var declaration_line = lines.shift();

		// check for excessive indentation of the first child style class
		if (declaration_line.tabs !== 0) {
			throw new Error('Excessive indentation (' + declaration_line.tabs + ' more "tabs" than needed) at line ' + declaration_line.index + ': "' + declaration_line.original_line + '"');
		}

		// style class name declaration
		var declaration = declaration_line.line;

		// child nodes' names
		var names = declaration.split(',').map(function (name) {
			return name.trim();
		});

		// style class nesting validation
		validate_child_style_class_types(parent_node_names, names);

		// parse own CSS styles and recursively parse all child nodes
		var style_json = parse_style_class(lines, names);

		// generate style json for this child node (or child nodes)
		return names.map(function (node_declaration) {
			// parse this child node name
			var _parse_node_name = parse_node_name(node_declaration),
			    name = _parse_node_name.name,
			    is_a_modifier = _parse_node_name.is_a_modifier;

			// clone the style JSON object for this child node


			var json = (0, _helpers.extend)({}, style_json);

			// set the modifier flag if it's the case
			if (is_a_modifier) {
				json._is_a_modifier = true;
			}

			// this child node's style JSON object
			return { name: name, json: json };
		});
	})
	// convert an array of arrays to a flat array
	.reduce(function (array, child_array) {
		return array.concat(child_array);
	}, [])
	// combine all the child nodes into a single JSON object
	.reduce(function (nodes, node) {
		// if style already exists for this child node, extend it
		if (nodes[node.name]) {
			(0, _helpers.extend)(nodes[node.name], node.json);
		} else {
			nodes[node.name] = node.json;
		}

		return nodes;
	}, {});
}

// filters out comments, blank lines, etc
function filter_lines_for_parsing(lines) {
	// filter out blank lines
	lines = lines.filter(function (line) {
		return !(0, _helpers.is_blank)(line.line);
	});

	lines.forEach(function (line) {
		// remove single line comments
		line.line = line.line.replace(/^\s*\/\/.*/, '');
		// remove any trailing whitespace
		line.line = line.line.trim();
	});

	return lines;
}

// takes the whole lines array and splits it by its top-tier child nodes
function split_lines_by_child_nodes(lines) {
	// determine lines with indentation = 0 (child node entry lines)
	var node_entry_lines = lines.map(function (line, index) {
		return { tabs: line.tabs, index: index };
	}).filter(function (line) {
		return line.tabs === 0;
	}).map(function (line) {
		return line.index;
	});

	// deduce corresponding child node ending lines
	var node_ending_lines = node_entry_lines.map(function (line_index) {
		return line_index - 1;
	});
	node_ending_lines.shift();
	node_ending_lines.push(lines.length - 1);

	// each child node boundaries in terms of starting line index and ending line index
	var from_to = (0, _helpers.zip)(node_entry_lines, node_ending_lines);

	// now lines are split by child nodes
	return from_to.map(function (from_to) {
		return lines.slice(from_to[0], from_to[1] + 1);
	});
}

// expand modifier style classes
function expand_modifier_style_classes(node) {
	var style = get_node_style(node);
	var pseudo_classes_and_media_queries_and_keyframes = get_node_pseudo_classes_and_media_queries_and_keyframes(node);

	var modifiers = (0, _keys2.default)(node)
	// get all modifier style class nodes
	.filter(function (name) {
		return (0, _typeof3.default)(node[name]) === 'object' && node[name]._is_a_modifier;
	});

	// for each modifier style class node
	modifiers.forEach(function (name) {
		// // delete the modifier flags
		// delete node[name]._is_a_modifier

		// include parent node's styles and pseudo-classes into the modifier style class node
		node[name] = (0, _helpers.extend)({}, style, pseudo_classes_and_media_queries_and_keyframes, node[name]);

		// expand descendant style class nodes of this modifier
		expand_modified_subtree(node, node[name]);
	});

	// for each modifier style class node
	modifiers.forEach(function (name) {
		// delete the modifier flags
		delete node[name]._is_a_modifier;
	});

	// recurse
	(0, _keys2.default)(node)
	// get all style class nodes
	.filter(function (name) {
		return (0, _typeof3.default)(node[name]) === 'object';
	})
	// for each style class node
	.forEach(function (name) {
		// recurse
		expand_modifier_style_classes(node[name]);
	});

	return node;
}

// extracts root css styles of this style class node
function get_node_style(node) {
	return (0, _keys2.default)(node)
	// get all CSS styles of this style class node
	.filter(function (property) {
		return (0, _typeof3.default)(node[property]) !== 'object';
	})
	// for each CSS style of this style class node
	.reduce(function (style, style_property) {
		style[style_property] = node[style_property];
		return style;
	}, {});
}

// extracts root pseudo-classes and media queries of this style class node
function get_node_pseudo_classes_and_media_queries_and_keyframes(node) {
	return (0, _keys2.default)(node)
	// get all child style classes this style class node, 
	// which aren't modifiers and are a pseudoclass or a media query or keyframes
	.filter(function (property) {
		return (0, _typeof3.default)(node[property]) === 'object' && (is_pseudo_class(property) || is_media_query(property) || is_keyframes(property)) && !node[property]._is_a_modifier;
	})
	// for each child style class of this style class node
	.reduce(function (pseudo_classes_and_media_queries_and_keyframes, name) {
		pseudo_classes_and_media_queries_and_keyframes[name] = node[name];
		return pseudo_classes_and_media_queries_and_keyframes;
	}, {});
}

// for each (non-modifier) child style class of the modifier style class, 
// check if "this child style class" is also present 
// as a (non-modifier) "child of the current style class".
// if it is, then extend "this child style class" with the style 
// from the "child of the current style class".
// (and repeat recursively)
function expand_modified_subtree(node, modified_node) {
	// from the modified style class node
	(0, _keys2.default)(modified_node)
	// for all non-pseudo-classes and non-media-queries
	.filter(function (name) {
		return !is_pseudo_class(name) && !is_media_query(name) && !is_keyframes(name);
	})
	// get all non-modifier style class nodes
	.filter(function (name) {
		return (0, _typeof3.default)(modified_node[name]) === 'object' && !modified_node[name]._is_a_modifier;
	})
	// which are also present as non-modifier style classes
	// in the base style class node
	.filter(function (name) {
		return (0, _typeof3.default)(node[name]) === 'object' && !node[name]._is_a_modifier;
	})

	// for each such style class node
	.forEach(function (name) {
		// style of the original style class node
		var style = get_node_style(node[name]);

		// pseudo-classes of the original style class node
		var pseudo_classes_and_media_queries_and_keyframes = get_node_pseudo_classes_and_media_queries_and_keyframes(node[name]);

		// mix in the styles
		modified_node[name] = (0, _helpers.extend)({}, style, pseudo_classes_and_media_queries_and_keyframes, modified_node[name]);

		// recurse
		return expand_modified_subtree(node[name], modified_node[name]);
	});
}

// checks if this style class name designates a pseudo-class
function is_pseudo_class(name) {
	return (0, _helpers.starts_with)(name, ':');
}

// checks if this style class name is a media query (i.e. @media (...))
function is_media_query(name) {
	return (0, _helpers.starts_with)(name, '@media');
}

function is_keyframe_selector(name) {
	return (0, _helpers.ends_with)(name, '%') || name === 'from' || name === 'to';
}

// checks if this style class name is a media query (i.e. @media (...))
function is_keyframes(name) {
	return (0, _helpers.starts_with)(name, '@keyframes');
}

// style class nesting validation
function validate_child_style_class_types(parent_node_names, names) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = (0, _getIterator3.default)(parent_node_names), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var parent = _step.value;

			// if it's a pseudoclass, it can't contain any style classes
			if (is_pseudo_class(parent) && (0, _helpers.not_empty)(names)) {
				throw new Error('A style class declaration "' + names[0] + '" found inside a pseudoclass "' + parent + '". Pseudoclasses (:hover, etc) can\'t contain child style classes.');
			}

			// if it's a media query style class, it must contain only pseudoclasses
			if (is_media_query(parent)) {
				var non_pseudoclass = names.filter(function (x) {
					return !is_pseudo_class(x);
				})[0];

				if (non_pseudoclass) {
					throw new Error('A non-pseudoclass "' + non_pseudoclass + '" found inside a media query style class "' + parent + '". Media query style classes can only contain pseudoclasses (:hover, etc).');
				}
			}

			// if it's a keyframes style class, it must contain only keyframe selectors
			if (is_keyframes(parent)) {
				var non_keyframe_selector = names.filter(function (x) {
					return !is_keyframe_selector(x);
				})[0];

				if (non_keyframe_selector) {
					throw new Error('A non-keyframe-selector "' + non_keyframe_selector + '" found inside a keyframes style class "' + parent + '". Keyframes style classes can only contain keyframe selectors (from, 100%, etc).');
				}
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

// parse CSS style class
function parse_style_class(lines, node_names) {
	// separate style lines from children lines
	var _split_into_style_lin = split_into_style_lines_and_children_lines(lines),
	    style_lines = _split_into_style_lin.style_lines,
	    children_lines = _split_into_style_lin.children_lines;

	// convert style lines info to just text lines


	var styles = style_lines.map(function (line) {
		return line.line;
	});

	// using this child node's (or these child nodes') style lines 
	// and this child node's (or these child nodes') child nodes' lines,
	// generate this child node's (or these child nodes') style JSON object
	// (this is gonna be a recursion)
	return parse_node_json(styles, children_lines, node_names);
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-styling/build/index.js
// module id = 410
// module chunks = 0